/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IVideoTutorialRepository } from "@/interface/videos-tutorias";

const videosTutoriasRepository: IVideoTutorialRepository = {
  async getVideoTutorial<T>(accessToken: string): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const response = await Instance.get("videos-tutorias", {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return response?.data;
  },
};

/**
 * EXPORTS
 */
export { videosTutoriasRepository };
